module.exports = __webpack_public_path__ + "static/img/mergeImage.2053635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2023default/index/mergeImage.png
// module id = gN5r
// module chunks = 2